import { createI18n } from 'vue-i18n';
import ar from '@/locales/ar.json';
import en from '@/locales/en.json';

export  const i18n = createI18n({
  locale: 'ar', // default locale
    messages: {
        ar,
        en,
    },
});
export function changeLanguageInHelpers(lang) {
    // to switch language
    i18n.global.locale = lang;
}
const {global:{t}}=i18n

import { required, numeric, email,minLength,maxLength,minValue,helpers,sameAs,between,} from '@vuelidate/validators'
const urlRegex = helpers.regex(/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi)
const locationUrlRegex = helpers.regex(/^https?:\/\/(?:www\.)?google\.com\/maps(?:\/?.*)?$/)
const notAcceptWhiteSpaceRegex=helpers.regex(/^\S+$/)//not contain white space at any part
const passwordRegex = helpers.regex(/[A-Z]+/,/[0-9]+/)//should be at least one capital char and one number
const noArabicRegex=helpers.regex(/^(?:(?![\u0600-\u06FF]).)*$/u)
const noSymbolsRegex=helpers.regex(/^[^!@#$%^&*(),.?":{}|<>[\]\-=+_~`';\\]*$/)
const noNumbersRegex=helpers.regex(/^[^\d]*$/)
const nonNegativeNumbersOnlyRegex = helpers.regex(/^(0|[1-9]\d*)(\.\d+)?$/);
// Email must be a valid email and end with gmail.com, yahoo.com, or outlook.com
const allowedEmailDomainsRegex = helpers.regex(
  /^[^\s@]+@(gmail\.com|yahoo\.com|hotmail\.com|outlook\.com|aol\.com|zoho\.com|hmaserv\.com)$/i
);

// 010
// 011
// 012
// 015
const startWith_0_1_Regex = helpers.regex(/^01[0125][0-9]*$/)
const telegramRegex=helpers.regex(/^[a-zA-Z0-9][a-zA-Z0-9_]{3,}[a-zA-Z0-9]$/)
const notEmptyRegex=helpers.regex(/^\s*$/)//not empty and not include white-space

const instagramLink=helpers.regex(/https:\/\/(?:www\.)?instagram\.com/);/*
regex accept instagram link: *with or without www.*
*/
const linkedinLink=helpers.regex(/https:\/\/(?:www\.)?linkedin\.com/);/*
regex accept linkedin link: *with or without www.*
*/

const facebookLink=helpers.regex(/https:\/\/(?:www\.)?facebook\.com/);/* 
regex accept facebook link: *with or without www.*
*/

const facebookVideoLink=helpers.regex(/^(?:https?:\/\/(?:www\.)?facebook.com\/(.*?)(?=\/videos\/(.*?))|https?:\/\/(?:www\.)?facebook.com\/watch\/(.*?)|https?:\/\/(?:www\.)?fb.watch\/(.*?)|https?:\/\/(?:www\.)?facebook.com\/share\/v\/(.*?)|https?:\/\/(?:www\.)?facebook.com\/reel\/(.*?)|https?:\/\/(?:www\.)?facebook.com\/share\/r\/(.*?)|https?:\/\/(?:www\.)?facebook.com\/watch\?v=(.*?)|https?:\/\/(?:www\.)?facebook.com\/share\/v\/(.*?)\/.*$)/);/*
This updated regex pattern will now match Facebook video URLs in the formats: *with or without www.*
https://www.facebook.com/{username}/videos/{video_id}
https://www.facebook.com/watch/{video_id}
https://fb.watch/{video_id}
https://www.facebook.com/{username}/videos/{video_id}
https://www.facebook.com/share/v/{video_id}
https://www.facebook.com/watch?v={video_id}
https://www.facebook.com/share/v/{video_id}/{anything else}
---new--
https://www.facebook.com/share/r/{{video_id}}
https://www.facebook.com/reel/{{video_id}}
 */

// const youtubeVideoLinkRegex=helpers.regex(/^(?:https:\/\/(?:www\.)?youtube\.com\/(?:watch\?v=|shorts\/)([a-zA-Z0-9_-]+)|(?:https:\/\/youtu\.be\/|https:\/\/(?:www\.)?youtube\.com\/shorts\/)([a-zA-Z0-9_-]+))$/);/*
// This updated regex pattern will now match YouTube video URLs in the formats: *with or without www.*
// https://www.youtube.com/watch?v={{video_id}}
// https://youtu.be/{{video_id}}
// https://www.youtube.com/shorts/{{video_id}}
//  */
const youtubeVideoLinkRegex=helpers.regex(/^(?:https?:\/\/(?:www\.)?youtube\.com\/(?:watch\?v=|shorts\/)([^\s\/]+)|(?:https?:\/\/youtu\.be\/([^\s\/]+))|(?:https?:\/\/(?:www\.)?youtube\.com\/shorts\/)([^\s\/]+))$/);/*
This updated regex pattern will now match YouTube video URLs in the formats: *with or without www.*
https://www.youtube.com/watch?v={{any thing even special chars}}
https://youtu.be/{{any thing even special chars}} 
https://www.youtube.com/shorts/{{any thing even special chars}}
 */


const youtubechannelLinkRegex =helpers.regex(/^(?:https?:\/\/(?:www\.)?youtube\.com\/(?:channel\/|user\/|c\/|@|@c\/|@user\/)([^\s\/]+)(?:\?[^\s]*)?$)/);/*
This updated regex pattern will now match YouTube channel URLs in the formats: *with or without www.*
https://www.youtube.com/channel/{{channel_id}}
https://www.youtube.com/user/{{channel_id}}
https://www.youtube.com/c/{{channel_id}}
https://www.youtube.com/@{{channel_id}}
https://www.youtube.com/@user/{{channel_id}}
https://www.youtube.com/@{{channel_id}}?si=xxxxx
 */

const facebookPixelIdRegex=helpers.regex(/^[0-9]*$/);/*
accept only numbers
*/
const specialCharsRegexStoreName=helpers.regex(/^[a-zA-Z0-9.\- \u0600-\u06FF@#&$%]*$/);/*
accept only  letters, numbers, dots (.), and hyphens (-) and whitespace and arabic  and @#&$%
*/
const specialCharsRegex=helpers.regex(/^[a-zA-Z0-9.\- \u0600-\u06FF]*$/);/*
accept only  letters, numbers, dots (.), and hyphens (-) and whitespace and arabic 
*/
const specialChars_StoreUserName_Regex=helpers.regex(/^(?![0-9]+$)[A-Za-z0-9_.-]+$/);/*
not accept numbers only, and not accept any special character except “-”, “.”, “_”
*/
const specialCharsRegexProductName= helpers.regex(/^[^&<>%\/\\?]+$/);/*
// helpers.regex(/^[^\/?&%]+$/);/*
accept any characters except the "/" and the "?" and '&' in java-script
*/
const notAccept_cezma_store_Regex=helpers.regex(/^(?!cezma\-store$).*/);/*
regex to not accept this string specific 'cezma-store'
*/
const not_accept_white_color_regex=helpers.regex(/^(?!#ffffff\b)(#[a-fA-F0-9]{6})$/);/*
regex to not accept this string specific 'cezma-store'
*/
// Custom validator to reject names containing "cezma" in any format (case-insensitive English or Arabic "سيزما")
// Also handles cases where "cezma" is separated by special characters (e.g., "c-e-z-m-a", "c.e.z.m.a")
const notAcceptCezmaRegex = (value) => {
    if (!value || typeof value !== 'string') return true; // Allow empty values (handled by required validator)
    const trimmedValue = value.trim();
    // Check for English "cezma" (case-insensitive) - direct match
    const englishPattern = /cezma/i;
    // Check for English "cezma" separated by special characters (c followed by any non-alphanumeric chars, then e, then z, then m, then a)
    // Pattern matches: c[special chars]e[special chars]z[special chars]m[special chars]a
    const englishSeparatedPattern = /c[^a-zA-Z0-9]*e[^a-zA-Z0-9]*z[^a-zA-Z0-9]*m[^a-zA-Z0-9]*a/i;
    // Check for Arabic "سيزما"
    const arabicPattern = /سيزما/;
    // Return false if any pattern is found (validation fails)
    return !(englishPattern.test(trimmedValue) || englishSeparatedPattern.test(trimmedValue) || arabicPattern.test(trimmedValue));
};





export const VALIDATIONS ={
    required:{
        // notEmptyRegex:helpers.withMessage(()=> t('general.validation_msg.required'),notEmptyRegex),
        required:helpers.withMessage(()=> t('general.validation_msg.required'),required),

    },
    requiredPositiveNum:{
        required:helpers.withMessage(()=> t('general.validation_msg.required'),required),
        nonNegativeNumbersOnlyRegex:helpers.withMessage(()=> t('general.validation_msg.min_num'),nonNegativeNumbersOnlyRegex)
    },
    username:{
        required:helpers.withMessage(()=> t('general.validation_msg.required'),required),
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(2)),
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(20)),
        notAcceptWhiteSpaceRegex:helpers.withMessage(()=> t('general.validation_msg.whitespace'),notAcceptWhiteSpaceRegex)
    },
    name:{
        required:helpers.withMessage(()=> t('general.validation_msg.required'),required),
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(2)),
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(20)),
        noSymbolsRegex:helpers.withMessage(()=>t('general.validation_msg.no_symbols'),noSymbolsRegex),
        noNumbersRegex:helpers.withMessage(()=>t('general.validation_msg.no_numbers'),noNumbersRegex),

    },
    email:{
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required), 
        email:helpers.withMessage(()=>t('general.validation_msg.email'),email),
        allowedEmailDomainsRegex: helpers.withMessage(() => t('general.validation_msg.email_must_be_valid_to_gmail_yahoo_hotmail_outlook_aol'), allowedEmailDomainsRegex)
    },
    optionalEmail:{
        // required:helpers.withMessage(()=>t('general.validation_msg.required'),required), 
        email:helpers.withMessage(()=>t('general.validation_msg.email'),email)
    },
    password: { 
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        // noArabicRegex:helpers.withMessage(t('general.validation_msg.no_arabic'),noArabicRegex),
        // passwordRegex:helpers.withMessage(t('general.validation_msg.password'),passwordRegex),//should be at least one capital char and one number
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(8)),
        // maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(20)),
    },
    storeName:{
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(2)),
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(50)),
        // specialCharsRegexStoreName:helpers.withMessage(()=> t('general.validation_msg.specialCharsRegex'),specialCharsRegexStoreName)
        notAcceptCezmaRegex:helpers.withMessage(()=> t('general.validation_msg.notAcceptCezmaRegex'),notAcceptCezmaRegex)

    },
    storeUsername:{
        required:helpers.withMessage(()=> t('general.validation_msg.required'),required),
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(2)),
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(50)),
        notAcceptWhiteSpaceRegex:helpers.withMessage(()=> t('general.validation_msg.whitespace'),notAcceptWhiteSpaceRegex),
        specialChars_StoreUserName_Regex:helpers.withMessage(()=> t('general.validation_msg.specialChars_StoreUserName_Regex'),specialChars_StoreUserName_Regex),
        notAccept_cezma_store_Regex:helpers.withMessage(()=> t('general.validation_msg.notAccept_cezma_store_Regex'),notAccept_cezma_store_Regex)
    },
    productName:{
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(2)),
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(70)),

        specialCharsRegexProductName:helpers.withMessage(()=> t('general.validation_msg.specialCharsRegexProductName'),specialCharsRegexProductName),
        notAcceptCezmaRegex:helpers.withMessage(()=> t('general.validation_msg.notAcceptCezmaRegex'),notAcceptCezmaRegex)
    },
    image:{
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
    },
    description: {
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(10)),
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(2000))
    },
    productDescription:{
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(2)),
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(2000))
    },
    storeDescriptionAdmin: {
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(5)),
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(2000))
    },
    storeDescriptionReseller: {
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(2)),
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(500))
    },
    // productDescription:{
    //     required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
    //     minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(10)),
    //     maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(2000))
    // },
    cancelledOrderReason: {
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(10)),
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(1000))
    },
    footerDescription: {
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(750))
    },
    sku: {
        numeric:helpers.withMessage(()=>t('general.validation_msg.number'),numeric),
    },
    phone: {
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        numeric:helpers.withMessage(()=>t('general.validation_msg.number'),numeric),
        startWith_0_1_Regex:helpers.withMessage(()=>`${t('general.validation_msg.invalid_number_must_start_with_0_1')}`,startWith_0_1_Regex),
        minLength:helpers.withMessage(()=>`${t('general.validation_msg.phone')}`,minLength(11)),
        maxLength:helpers.withMessage(()=>`${t('general.validation_msg.phone')}`,maxLength(11)),
    },
    phones: {
       
        required,
        minLength: minLength(1),
     
        $each: helpers.forEach({
          val: { 
            required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
            numeric:helpers.withMessage(()=>t('general.validation_msg.number'),numeric),
            startWith_0_1_Regex:helpers.withMessage(()=>`${t('general.validation_msg.invalid_number_must_start_with_0_1')}`,startWith_0_1_Regex),
            minLength:helpers.withMessage(()=>`${t('general.validation_msg.phone')}`,minLength(11)),
            maxLength:helpers.withMessage(()=>`${t('general.validation_msg.phone')}`,maxLength(11)),
          },
        })
     
    },
    street: {
        required:helpers.withMessage(()=>t('general.addresses.street_required'),required),
    },
    phone2: {
        numeric:helpers.withMessage(()=>t('general.validation_msg.number'),numeric),
        startWith_0_1_Regex:helpers.withMessage(()=>`${t('general.validation_msg.invalid_number')}`,startWith_0_1_Regex),
        minLength:helpers.withMessage(()=>`${t('general.validation_msg.phone')}`,minLength(11)),
        maxLength:helpers.withMessage(()=>`${t('general.validation_msg.phone')}`,maxLength(11)),
    },
    
    address: {
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(10)),
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(200))
    },
    notes: {
        // required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(10)),
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(500))
    },
    orderAddress: {
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(2)),
    },
    storeAddress: {
        // required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(5)),
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(500))
    },
    twak_chat: {
        required: helpers.withMessage(()=>t('general.validation_msg.required'),required),
    },
    location: {
        locationUrlRegex:helpers.withMessage(t('general.validation_msg.location'),locationUrlRegex),
    },
    color: {
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        // not_accept_white_color_regex:helpers.withMessage(()=>t('general.validation_msg.not_accept_white_color'),not_accept_white_color_regex)
    },
    mainColor: {
        // required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        not_accept_white_color_regex:helpers.withMessage(()=>t('general.validation_msg.not_accept_white_color'),not_accept_white_color_regex)
    },
    // url: {
    //     urlRegex:helpers.withMessage(()=>t('general.validation_msg.url'),urlRegex)
    // },
    url: {
        urlRegex:helpers.withMessage(()=>t('general.validation_msg.url'),urlRegex)
    },
    requiredInput: {
        required: helpers.withMessage(()=> t('general.validation_msg.required'),required),
    },
    socialMedia: {
        urlRegex:helpers.withMessage(()=>t('general.validation_msg.url'),urlRegex)
    },
    linkedin: {
        linkedinLink: helpers.withMessage(()=> t('general.validation_msg.url'),linkedinLink),
    },
    instagram: {
        instagramLink:helpers.withMessage(()=>t('general.validation_msg.url'),instagramLink),
    },
    facebook: {
        facebookLink:helpers.withMessage(()=>t('general.validation_msg.url'),facebookLink),
    },
    telegram: {
        telegramRegex:helpers.withMessage(()=>t('general.validation_msg.telegram'),telegramRegex)
    },
    facebookVideoLink: {
        facebookVideoLink:helpers.withMessage(()=>t('general.facebook_url_link_invalid'),facebookVideoLink),
    },
    youtubeVideoLink: {
        youtubeVideoLinkRegex:helpers.withMessage(()=>t('general.youtube_url_link_invalid'),youtubeVideoLinkRegex),
    },
    youtubeChannelLink: {
        youtubechannelLinkRegex:helpers.withMessage(()=>t('general.youtube_url_link_invalid'),youtubechannelLinkRegex),
    },
    facebook_pixel_id: {
        facebookPixelIdRegex:helpers.withMessage(()=>t('general.facebook_pixel_id_invalid'),facebookPixelIdRegex),
    },
    whatsapp: {
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        numeric:helpers.withMessage(()=>t('general.validation_msg.whatsapp'),numeric),
        startWith_0_1_Regex:helpers.withMessage(()=>`${t('general.validation_msg.invalid_whatsapp')}`,startWith_0_1_Regex),
        minLength:helpers.withMessage(()=>`${t('general.validation_msg.phone')}`,minLength(11)),
        maxLength:helpers.withMessage(()=>`${t('general.validation_msg.phone')}`,maxLength(11)),
    },
    whatsapp_admin: {
        numeric:helpers.withMessage(()=>t('general.validation_msg.whatsapp'),numeric),
        startWith_0_1_Regex:helpers.withMessage(()=>`${t('general.validation_msg.invalid_whatsapp')}`,startWith_0_1_Regex),
        minLength:helpers.withMessage(()=>`${t('general.validation_msg.phone')}`,minLength(11)),
        maxLength:helpers.withMessage(()=>`${t('general.validation_msg.phone')}`,maxLength(11)),
    },
    reportDescription: {
        required:helpers.withMessage(()=>t('general.validation_msg.required'),required),
        minLength:helpers.withMessage(($params)=>`${t('general.validation_msg.min')}${$params.$params.min}`,minLength(10)),
        maxLength:helpers.withMessage(($params)=>`${t('general.validation_msg.max')}${$params.$params.max}`,maxLength(2000))
    },
    videoInput: {
        // required: helpers.withMessage(()=> t('general.validation_msg.required'),required),
        isYoutubeURL: helpers.withMessage(
            () => t("general.youtube_link_invalid"),
            (value) =>              !value || /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/.test(value)
            ,
        )
    }
}